export default __webpack_public_path__ + "static/media/girl.58b2c75a.png";